import { TargetType } from '@megaphone/types'
import { RecurrenceEdit } from './core'
import { IconsSet } from './core.models'

export const isIFrameLoaded = (): boolean => {
  return window !== window.parent
}

export const WEEKDAYS = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
]

export const TARGET_TYPES: TargetType[] = [
  'private',
  'contributor',
  'inhabitant',
  'user',
  'everybody',
] // Use viewer instead

export const RECURRENCE_EDIT_TYPES: RecurrenceEdit[] = ['current', 'all']

export const EDITOR_OPTIONS_LIGHT = {
  language: 'css',
  minimap: { enabled: false },
  automaticLayout: true,
  theme: 'vs-light',
}
export const EDITOR_OPTIONS_DARK = {
  language: 'css',
  minimap: { enabled: false },
  automaticLayout: true,
  theme: 'vs-dark',
}

// Both news, places & events

export const ICONS_SET_NEWS: IconsSet[] = [
  {
    title: 'COMMUNITY_NEWS',
    icons: [
      'notifications',
      'lightbulb',
      'info',
      'info_outline',
      'new_releases',
      'star',
      'public',
      'home',
      'sticky_note_2',
      'chat',
    ],
  },
  {
    title: 'HAZARD_REPORTS',
    icons: [
      'warning',
      'warning_amber',
      'error',
      'error_outline',
      'new_releases',
      'gpp_maybe',
      'notification_important',
      'priority_high',
      'coronavirus',
      'bug_report',
    ],
  },
  {
    title: 'ADMINISTRATIVE',
    icons: [
      'public',
      'groups',
      'work',
      'email',
      'library_books',
      'article',
      'sticky_note_2',
      'description',
      'how_to_vote',
      'gavel',
    ],
  },
  {
    title: 'CONSTRUCTION',
    icons: [
      'engineering',
      'construction',
      'handyman',
      'hardware',
      'gite',
      'maps_home_work',
      'apartment',
      'home',
      'house_siding',
      'roofing',
    ],
  },
  {
    title: 'TRAFFIC',
    icons: [
      'warning',
      'warning_amber',
      'construction',
      'traffic',
      'commute',
      'train',
      'directions_car',
      'minor_crash',
      'local_shipping',
      'directions_boat',
    ],
  },
  {
    title: 'PUBLIC',
    icons: [
      'school',
      'square_foot',
      'brush',
      'emoji_emotions',
      'gite',
      'health_and_safety',
      'elderly',
      'elderly_woman',
      'church',
      'add_circle_outline',
    ],
  },
  {
    title: 'TOURISM',
    icons: [
      'public',
      'park',
      'forest',
      'filter_hdr',
      'location_on',
      'hiking',
      'nordic_walking',
      'downhill_skiing',
      'museum',
      'event_available',
    ],
  },
  {
    title: 'CULTURE',
    icons: [
      'public',
      'agriculture',
      'local_florist',
      'collections',
      'photo_camera',
      'groups',
      'shopping_cart',
      'brush',
      'museum',
      'music_note',
    ],
  },
]

export const ICONS_SET_REPORTS: IconsSet[] = [
  {
    title: 'HAZARD_REPORTS',
    icons: [
      'warning',
      'warning_amber',
      'error',
      'error_outline',
      'new_releases',
      'gpp_maybe',
      'notification_important',
      'priority_high',
      'coronavirus',
      'bug_report',
    ],
  },
]

export const ICONS_SET_EVENTS: IconsSet[] = [
  {
    title: 'ENTERTAINMENT',
    icons: [
      'celebration',
      'local_bar',
      'nightlife',
      'music_note',
      'library_music',
      'movie',
      'theaters',
      'confirmation_number',
      'local_activity',
      'theater_comedy',
    ],
  },
  {
    title: 'SPORTS',
    icons: [
      'sports_soccer',
      'sports_volleyball',
      'sports_tennis',
      'golf_course',
      'fitness_center',
      'directions_run',
      'directions_bike',
      'skateboarding',
      'downhill_skiing',
      'pool',
    ],
  },
  {
    title: 'CULTURE',
    icons: [
      'public',
      'agriculture',
      'local_florist',
      'collections',
      'photo_camera',
      'groups',
      'shopping_cart',
      'brush',
      'museum',
      'music_note',
    ],
  },
  {
    title: 'COMMUNITY',
    icons: [
      'church',
      'add_circle_outline',
      'local_hospital',
      'school',
      'brush',
      'groups',
      'family_restroom',
      'child_friendly',
      'elderly',
      'elderly_woman',
    ],
  },
]

export const ICONS_SET_PLACES: IconsSet[] = [
  {
    title: 'ACCOMMODATIONS',
    icons: [
      'home',
      'cottage',
      'museum',
      'gite',
      'holiday_village',
      'maps_home_work',
      'apartment',
      'king_bed',
      'hotel',
      'chair',
    ],
  },
  {
    title: 'SPORTS',
    icons: [
      'sports_soccer',
      'sports_volleyball',
      'sports_hockey',
      'sports_tennis',
      'golf_course',
      'fitness_center',
      'directions_bike',
      'skateboarding',
      'downhill_skiing',
      'pool',
    ],
  },
  {
    title: 'PUBLIC_PLACES',
    icons: [
      'church',
      'museum',
      'storefront',
      'store',
      'shopping_cart',
      'restaurant_menu',
      'restaurant',
      'fastfood',
      'liquor',
      'wine_bar',
    ],
  },
  {
    title: 'NATURE',
    icons: [
      'filter_hdr',
      'park',
      'forest',
      'local_florist',
      'filter_vintage',
      'yard',
      'wb_sunny',
      'waves',
      'water',
      'water_drop',
    ],
  },
]

export const ICONS_SET_SHOPS: IconsSet[] = [
  {
    title: 'RESTAURANTS',
    icons: [
      'restaurant',
      'local_cafe',
      'takeout_dining',
      'local_bar',
      'fastfood',
      'local_pizza',
      'bakery_dining',
      'icecream',
      'delivery_dining',
      'cake',
    ],
  },
  {
    title: 'STORES',
    icons: [
      'store',
      'storefront',
      'shopping_cart',
      'shopping_bag',
      'checkroom',
      'local_florist',
      'chair',
      'local_library',
      'devices',
      'pets',
    ],
  },
]

export const ICONS_SET_FORMS: IconsSet[] = [
  {
    title: 'RESTAURANTS',
    icons: [
      'restaurant',
      'local_cafe',
      'takeout_dining',
      'local_bar',
      'fastfood',
      'local_pizza',
      'bakery_dining',
      'icecream',
      'delivery_dining',
      'cake',
    ],
  },
  {
    title: 'STORES',
    icons: [
      'store',
      'storefront',
      'shopping_cart',
      'shopping_bag',
      'checkroom',
      'local_florist',
      'chair',
      'local_library',
      'devices',
      'pets',
    ],
  },
]

export const ICONS_SET_MENUS: IconsSet[] = [
  {
    title: 'FOOD',
    icons: [
      'restaurant',
      'takeout_dining',
      'fastfood',
      'local_pizza',
      'bakery_dining',
      'icecream',
      'delivery_dining',
      'cake',
      'kebab_dining',
      'ramen_dining',
    ],
  },
  {
    title: 'DRINKS',
    icons: [
      'local_cafe',
      'local_bar',
      'local_drink',
      'sports_bar',
      'wine_bar',
      'liquor',
      'emoji_food_beverage',
      'blender',
      'water_drop',
      'coffee',
    ],
  },
]

export const ICONS_SET_BOOKINGS: IconsSet[] = [
  {
    title: 'PLACES',
    icons: [
      'home',
      'cottage',
      'apartment',
      'hotel',
      'skateboarding',
      'factory',
      'meeting_room',
      'nightlife',
      'restaurant_menu',
      'restaurant',
    ],
  },
]

export const ICONS_SET_CHATS: IconsSet[] = [
  {
    title: 'ADMINISTRATIVE',
    icons: [
      'public',
      'groups',
      'work',
      'email',
      'library_books',
      'article',
      'sticky_note_2',
      'description',
      'how_to_vote',
      'gavel',
    ],
  },
]

export const ICONS_SET_HIKES: IconsSet[] = [
  {
    title: 'NATURE',
    icons: [
      'filter_hdr',
      'park',
      'forest',
      'local_florist',
      'filter_vintage',
      'yard',
      'wb_sunny',
      'waves',
      'water',
      'water_drop',
    ],
  },
  {
    title: 'EN_ROUTE',
    icons: [
      'hiking',
      'nordic_walking',
      'snowshoeing',
      'directions_walk',
      'transfer_within_a_station',
      'follow_the_signs',
      'signpost',
      'explore',
      'assistant_navigation',
      'navigation',
    ],
  },
]

export const ICONS_SET_WEBCAMS: IconsSet[] = [
  {
    title: 'NATURE',
    icons: [
      'filter_hdr',
      'forest',
      'park',
      'local_florist',
      'filter_vintage',
      'water',
      'water_drop',
      'wb_sunny',
      'visibility',
      'videocam',
    ],
  },
]

export const ICONS_SET_CONTACTS: IconsSet[] = [
  {
    title: 'MISCELLANEOUS',
    icons: [
      'contact_phone',
      'contact_mail',
      'menu_book',
      'construction',
      'engineering',
      'local_fire_department',
      'account_balance',
      'gavel',
      'local_hospital',
      'school',
    ],
  },
]
export const ICONS_SET_OPENINGS: IconsSet[] = [
  {
    title: 'MISCELLANEOUS',
    icons: [
      'schedule',
      'watch_later',
      'calendar_month',
      'date_range',
      'museum',
      'support_agent',
      'call',
      'email',
      'web',
      'meeting_room',
    ],
  },
]
export const ICONS_SET_WEBSITE: IconsSet[] = [
  {
    title: 'MISCELLANEOUS',
    icons: [
      'home',
      'museum',
      'gavel',
      'how_to_vote',
      'article',
      'chat',
      'help',
      'public',
      'groups',
      'directions_car',
    ],
  },
]

export const ICONS_SET_WEBSITE_MENU: IconsSet[] = [
  {
    title: 'SYMBOLS',
    icons: [
      'error_outline',
      'warning_amber',
      'notification_important',
      'priority_high',
      'report',
      'new_releases',
      'info',
      'help',
      'privacy_tip',
      'done',
      'check_circle',
      'dangerous',
      'add_circle',
      'clear',
      'not_interested',
      'star',
      'favorite_border',
      'verified',
      'highlight_off',
      'done_all',
      'delete',
      'percent',
      'refresh',
      'bolt',
    ],
  },
  {
    title: 'SOZIAL',
    icons: [
      'person',
      'people',
      'groups',
      'face',
      'mood',
      'sentiment_very_satisfied',
      'sentiment_dissatisfied',
      'family_restroom',
      'elderly',
      'school',
      'public',
      'emoji_events',
      'engineering',
      'whatsapp',
      'female',
      'male',
      'smoking_rooms',
      'smoke_free',
      'coronavirus',
      'masks',
      'wash',
      'sick',
      'attribution',
      'waving_hand',
    ],
  },
  {
    title: 'TRAFFIC',
    icons: [
      'commute',
      'directions_car',
      'local_shipping',
      'directions_walk',
      'directions_run',
      'delivery_dining',
      'directions_bus',
      'directions_bike',
      'departure_board',
      'electric_bike',
      'electric_scooter',
      'electric_car',
      'traffic',
      'sports_motorsports',
      'directions',
      'local_shipping',
      'train',
      'directions_boat',
      'subway',
      'local_airport',
      'agriculture',
      'child_friendly',
      'pedal_bike',
      'airport_shuttle',
    ],
  },
  {
    title: 'ADMINISTRATIVE',
    icons: [
      'description',
      'book',
      'assessment',
      'library_books',
      'insert_comment',
      'event_available',
      'event_busy',
      'event_note',
      'today',
      'timer',
      'edit_calendar',
      'show_chart',
      'schedule',
      'account_circle',
      'lock',
      'bookmark',
      'mail',
      'chats',
      'folder',
      'place',
      'attach_money',
      'smartphone',
      'computer',
      'desktop_windows',
    ],
  },
  {
    title: 'ACTIVITIES',
    icons: [
      'downhill_skiing',
      'snowboarding',
      'directions_run',
      'snowshoeing',
      'directions_bike',
      'pool',
      'sports_tennis',
      'sports_soccer',
      'emoji_events',
      'fitness_center',
      'ice_skating',
      'celebration',
      'school',
      'hiking',
      'photo_camera',
      'brush',
      'fastfood',
      'mode_edit',
      'headphones',
      'speaker',
      'coffee',
      'print',
      'ondemand_video',
      'how_to_vote',
    ],
  },
  {
    title: 'LIVING',
    icons: [
      'home',
      'cottage',
      'apartment',
      'gite',
      'work',
      'weekend',
      'savings',
      'pets',
      'school',
      'light',
      'sports_bar',
      'recycling',
      'nights_stay',
      'phone_iphone',
      'computer',
      'desktop_windows',
    ],
  },
  {
    title: 'FOOD',
    icons: [
      'restaurant_menu',
      'restaurant',
      'local_pizza',
      'fastfood',
      'lunch_dining',
      'emoji_food_beverage',
      'icecream',
      'bakery_dining',
      'nightlife',
      'kebab_dining',
      'wine_bar',
      'liquor',
      'brunch_dining',
      'outdoor_grill',
      'rice_bowl',
      'tapas',
      'local_cafe',
    ],
  },
]
